import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/modal';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import ScrollReveal from 'scrollreveal';
import Lottie from 'lottie-web';

export default class Utils {

    constructor() {
        Utils.click();
        Utils.bootstrap();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.block_cover();
        Utils.obfuscation();
        Utils.show_more();
        Utils.scroll_reveal_init();
        Utils.lottie();
    }

    static lottie() {
        const imageClientsAnimation = document.getElementById('imageClientsAnimation');
        const imageCommercantsAnimation = document.getElementById('imageCommercantsAnimation');
        const imageCollectivitesAnimation = document.getElementById('imageCollectivitesAnimation');

        ScrollReveal().reveal(imageClientsAnimation, {
            reset: false,
            origin: 'bottom',
            duration: '0',
            delay: '0',
            distance: '500px',
            easing: 'ease',
            afterReveal: function animate() {
                let image_clients = {
                    container: imageClientsAnimation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: Theme.theme_url + '/partials/animations/image-clients.json'
                };
                image_clients = Lottie.loadAnimation(image_clients);
                image_clients.play();
            }
        });
        /*ScrollReveal().reveal(imageCommercantsAnimation, {
            reset: false,
            origin: 'bottom',
            duration: '0',
            delay: '0',
            distance: '500px',
            easing: 'ease',
            afterReveal: function animate() {
                let image_clients = {
                    container: imageCommercantsAnimation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: Theme.theme_url + '/partials/animations/image-clients.json'
                };
                image_clients = Lottie.loadAnimation(image_clients);
                image_clients.play();
            }
        });
        ScrollReveal().reveal(imageCollectivitesAnimation, {
            reset: false,
            origin: 'bottom',
            duration: '0',
            delay: '0',
            distance: '500px',
            easing: 'ease',
            afterReveal: function animate() {
                let image_clients = {
                    container: imageCollectivitesAnimation,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: Theme.theme_url + '/partials/animations/image-clients.json'
                };
                image_clients = Lottie.loadAnimation(image_clients);
                image_clients.play();
            }
        });*/
    }

    static scroll_reveal_init() {
        const fade_in_bottom = $('[data-scroll-revealed="fade-in-bottom"]');
        ScrollReveal().reveal(fade_in_bottom, {
            reset: false,
            origin: 'bottom',
            duration: '500',
            delay: '0',
            distance: '500px',
            easing: 'ease',
        });
    }

    static click() {
        const trigger = '[data-trigger="wpiris-click"]';

        if (!Modernizr.touchevents) {
            let ctrl = 0;
            $(window).on('keydown', function (e) {
                if (e.which == 17 || e.which == 91) {
                    ctrl = true
                }
            })
            $(window).on('keyup', function () {
                ctrl = false
            })

            $(document).on('mouseup', trigger, function (e) {

                if (e.target.tagName.toLowerCase() !== 'a') {
                    if (e.which == 1 || e.which == 2) {
                        let blank = false
                        let url = $(this).find("a").attr("href")
                        if (e.which == 2) {
                            blank = true
                        } // Clic molette
                        if ($(this).find("a").attr("target") == "_blank") {
                            blank = true
                        }
                        if (blank || ctrl) {
                            window.open(url, '_blank')
                        } else {
                            window.location = url
                        }
                        return false
                    }
                }
                return false

            })
        } else {
            $(document).on('click', trigger, function (e) {

                let blank = false
                let url = $(this).find("a").attr("href")
                if ($(this).find("a").attr("target") == "_blank") {
                    blank = true
                }
                if (blank) {
                    window.open(url, '_blank')
                } else {
                    window.location = url
                }
                return false

            })
        }
    }

    static bootstrap() {
        if (!Modernizr.touchevents) {
            $('[data-toggle="tooltip"]').tooltip({trigger: "hover"})
        }

        $('[data-toggle="popover"]').popover();
    }

    static fancybox() {

        $('.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")').each(function () {

            const href = $(this).attr('href');

            if (href.match(/(.jpg|.jpeg|.png|.gif|.svg|.webp)$/)) {
                $(this).attr('data-fancybox', 'fancybox');
            } else {
                if (href.indexOf(Theme.server_url) === -1) {
                    $(this).attr('target', '_blank');
                }
            }
        });


        let counter = 0;
        $('.hentry .wp-block-gallery').each(function () {
            counter++;
            $(this).find('a:has(>img)').attr('data-fancybox', 'wp-block-gallery-' + counter);
        });

        counter = 0;
        $('.hentry .wp-block-image').each(function () {
            counter++;
            $(this).find('a:has(>img)').attr('data-fancybox', 'wp-block-image-' + counter);
        });

        $('[data-fancybox]').fancybox({
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            backFocus: false,
            lang: "fr",
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancybox_close,
                    NEXT: Theme.translate.fancybox_next,
                    PREV: Theme.translate.fancybox_prev,
                    ERROR: Theme.translate.fancybox_error,
                    PLAY_START: Theme.translate.fancybox_start,
                    PLAY_STOP: Theme.translate.fancybox_stop,
                    FULL_SCREEN: Theme.translate.fancybox_full_screen,
                    THUMBS: Theme.translate.fancybox_thumbs,
                    DOWNLOAD: Theme.translate.fancybox_download,
                    SHARE: Theme.translate.fancybox_share,
                    ZOOM: Theme.translate.fancybox_zoom
                },
            },
            caption: function (instance, item) {
                let caption = $(this).closest('figure').find('figcaption').html()

                if (!caption) {
                    caption = $(this).find('img').attr('title')
                }

                if (!caption) {
                    caption = $(this).find('img').attr('alt')
                }

                return caption
            }
        })
    }

    static searchbox() {
        const trigger = '[data-trigger="wpiris-search-layout"]',
            close = '[data-trigger="wpiris-search-layout-close"]',
            $element = $('[data-id="wpiris-search-layout"]');

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        })

        $(document).on('click', close, function (e) {
            e.preventDefault();
            $element.fadeOut();
        })
    }

    static smooth_scroll() {
        const trigger = '[data-trigger="wpiris-scroll"]';

        $(document).on('click', trigger, function (e) {
            e.preventDefault();

            const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href"),
                duration = 1000,
                scroll_top = $(target).offset().top - (undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0);

            $('html, body').animate({
                scrollTop: scroll_top
            }, {
                duration: duration,
                step: (now, fx) => {
                    let real_pos = scroll_top;
                    if (fx.end !== real_pos) {
                        fx.end = real_pos;
                    }
                }
            });
        })
    }

    static lazy() {
        const lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
        });
        window.onbeforeprint = function () {
            lazyLoadInstance.loadAll();
        };
    }

    static block_cover() {
        $('.wp-block-cover:has(.wp-block-cover__inner-container a)').attr('data-trigger', 'wpiris-click')
    }

    static obfuscation() {
        let element = "[data-obf]";
        if ($(element).length > 0) {
            if (!Modernizr.touchevents) {
                let ctrl = 0;
                $(window).on('keydown', function (e) {
                    if (e.which == 17 || e.which == 91) {
                        ctrl = true;
                    }
                });
                $(window).on('keyup', function () {
                    ctrl = false;
                });

                $(document).on('mouseup', element, function (e) {
                    let url = atob($(this).attr('data-obf'));
                    let target = $(this).attr('data-obf-target');
                    if (e.which == 1 || e.which == 2) {
                        let blank = false;
                        if (e.which == 2) {
                            blank = true;
                        } // Clic molette
                        if (target == "_blank") {
                            blank = true;
                        }
                        if (blank || ctrl) {
                            window.open(url, '_blank');
                        } else {
                            window.location = url;
                        }
                        return false;
                    }

                    return false;

                });
            } else {
                $(document).on('click', element, function (e) {
                    let blank = false;
                    let url = atob($(this).attr('data-obf'));
                    let target = $(this).attr('data-obf-target');
                    if (target == "_blank") {
                        blank = true;
                    }
                    if (blank) {
                        window.open(url, '_blank');
                    } else {
                        window.location = url;
                    }
                    return false;
                });
            }
        }
    }

    static show_more() {
        let trigger = "[data-trigger='wpiris-show-more']";

        $(document).on('click', trigger, function (e) {
            e.preventDefault();
            let attr = $(this).attr('href');
            $(attr).toggleClass('show');
            $(this).hide();
        });
    }
}
